import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const createVehicle = async (payload) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/vehicles/`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    throw e;
  }
};

const getVehicle = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/user_panel/vehicles`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Vehicle data fetch error:", error);
    throw error;
  }
};

const editVehicle = async ({
  vehicle_id,
  customer,
  license_plate_number,
  driver_name,
  driver_contact,
  manufacturing_year,
}) => {
  try {
    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/vehicles/`,
      {
        vehicle_id,
        customer,
        license_plate_number,
        driver_name,
        driver_contact,
        manufacturing_year,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res;
  } catch (e) {
    console.error("Error updating vehicle:", e);
    throw e;
  }
};

const deleteVehicle = async (vehicle_id) => {
  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/vehicles/`,
      {
        data: { vehicle_id },
        unlink_only: "True",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res;
  } catch (e) {
    console.error("Error deleting vehicle:", e);
    return e;
  }
};

export { createVehicle, getVehicle, editVehicle, deleteVehicle };
